import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openLightDare } from "./openLightDareAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories:[],
    UsedQuestionsId:[],
    LastCard: false,
}

export const openLightDareAsync = createAsyncThunk(
    "/openlightdare",
    async ({gender, player}, {getState, rejectWithValue}) => {
        try {
            const state = getState()
            const usedid = state.openLightDare.UsedQuestionsId
            const selectedaccessories = state.openLightDare.Accessories
            const sessionid = state.gameStatus.sessions['open'].sessionId

            
            
            const response = await openLightDare(gender, player, usedid, selectedaccessories, sessionid);
            return response
        } catch (error) {
            console.error("Error in openLightDareAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
)

export const openLightDareSlice = createSlice({
    name: "openlightdare",
    initialState,
    reducers: {
        setAccessories: (state, action) =>{
            state.Accessories = action.payload
        },
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.DrinkQuestion = ''
            state.Attributes = []
            state.Accessories = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(openLightDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(openLightDareAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectOpenLightDare = (state) => state.openLightDare
export const { setAccessories, resetState } = openLightDareSlice.actions;
export default openLightDareSlice.reducer